/**
 * This file was auto-generated by Fern from our API Definition.
 */
import { SchemaDiffData } from "./SchemaDiffData";
export const SchemaDiffRecord = SchemaDiffData;
